import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { StatusBadge } from "../../components/StatusBadge";

export default function AdminEmailLog() {
  useEffect(() => { document.title = "Email Log | Sambiva Admin"; }, []);
  const { data: logs = [] } = useQuery({ queryKey: ["admin-email-logs"], queryFn: async () => (await api.get("/admin/email-logs")).data });

  return (
    <AdminLayout title="Email Log">
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-[#f6f7f9] text-sambiva-muted text-left">
            <tr><th className="px-4 py-3 font-semibold">Date</th><th className="px-4 py-3 font-semibold">Recipient</th><th className="px-4 py-3 font-semibold">Company</th><th className="px-4 py-3 font-semibold">Template</th><th className="px-4 py-3 font-semibold">Subject</th><th className="px-4 py-3 font-semibold">Status</th></tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} data-testid={`email-log-${l.id}`} className="border-t border-black/5 hover:bg-sambiva-cream/30">
                <td className="px-4 py-3 text-sambiva-muted whitespace-nowrap">{new Date(l.date).toLocaleString()}</td>
                <td className="px-4 py-3 text-sambiva-charcoal">{l.recipient}</td>
                <td className="px-4 py-3 text-sambiva-muted">{l.company || "—"}</td>
                <td className="px-4 py-3"><span className="text-xs font-medium bg-sambiva-cream px-2 py-1 rounded-full">{l.template}</span></td>
                <td className="px-4 py-3 text-sambiva-muted">{l.subject}</td>
                <td className="px-4 py-3"><StatusBadge status={l.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <div className="p-10 text-center text-sambiva-muted">No emails logged yet.</div>}
      </div>
    </AdminLayout>
  );
}
